/**
 * Financial Policy Constants
 * 
 * These constants reference fee and financial policy values from the backend.
 * They provide type safety for financial configuration without hardcoding.
 * 
 * IMPORTANT: These must match the values stored in the backend database.
 * Values are configurable via the admin panel's financial policies management.
 */

export const LATE_FEE_CALCULATION_METHODS = {
    FIXED_AMOUNT: 'FIXED_AMOUNT',
    PERCENTAGE: 'PERCENTAGE',
    DAILY_RATE: 'DAILY_RATE',
} as const;

export const LATE_FEE_FREQUENCIES = {
    ONE_TIME: 'ONE_TIME',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
} as const;

export const FEE_STRUCTURE_STATUSES = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    SCHEDULED: 'SCHEDULED',
    INACTIVE: 'INACTIVE',
    ARCHIVED: 'ARCHIVED',
} as const;

export const ASSIGNED_PLAN_STATUSES = {
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    DEFAULTED: 'DEFAULTED',
    CANCELLED: 'CANCELLED',
} as const;



export const LATE_FEE_CALCULATION_METHOD_OPTIONS = Object.values(LATE_FEE_CALCULATION_METHODS).map((value) => ({
    label: value.replace(/_/g, ' '),
    value,
}));

export const LATE_FEE_FREQUENCY_OPTIONS = Object.values(LATE_FEE_FREQUENCIES).map((value) => ({
    label: value.replace(/_/g, ' '),
    value,
}));
